interface ListSkeletonProps {
  /** card: kenarlıklı içerik kartı satırları; row: tek satırlık liste görünümü (örn. sohbet listesi). */
  variant?: 'card' | 'row';
  rows?: number;
  testId?: string;
}

function RowSkeleton() {
  return (
    <div className="flex items-center gap-3 px-3 py-2.5">
      <div className="h-9 w-9 shrink-0 animate-pulse rounded-full bg-slate-100" />
      <div className="min-w-0 flex-1 space-y-1.5">
        <div className="h-4 w-2/3 animate-pulse rounded bg-slate-100" />
        <div className="h-3 w-1/3 animate-pulse rounded bg-slate-100" />
      </div>
      <div className="h-4 w-10 shrink-0 animate-pulse rounded bg-slate-100" />
    </div>
  );
}

function CardSkeleton() {
  return (
    <div className="space-y-2 rounded-xl border border-slate-200 bg-white p-4">
      <div className="flex items-center gap-2">
        <div className="h-5 w-16 animate-pulse rounded-full bg-slate-100" />
        <div className="h-4 flex-1 animate-pulse rounded bg-slate-100" />
        <div className="h-4 w-10 animate-pulse rounded bg-slate-100" />
      </div>
      <div className="h-3.5 w-3/4 animate-pulse rounded bg-slate-100" />
      <div className="h-3.5 w-1/2 animate-pulse rounded bg-slate-100" />
    </div>
  );
}

/**
 * Liste yükleme iskeleti — tam ekran spinner yerine sayfa yerleşimini koruyan
 * pulse satırları (stil: ReleaseNotesCard yükleme deseniyle uyumlu).
 */
export function ListSkeleton({ variant = 'card', rows = 5, testId = 'list-skeleton' }: ListSkeletonProps) {
  return (
    <div data-testid={testId} role="status" aria-busy="true" aria-label="Yükleniyor">
      <span className="sr-only">Yükleniyor…</span>
      <div className={variant === 'row' ? 'divide-y divide-slate-50' : 'space-y-2'}>
        {Array.from({ length: rows }, (_, i) =>
          variant === 'row' ? <RowSkeleton key={i} /> : <CardSkeleton key={i} />,
        )}
      </div>
    </div>
  );
}
